import Marquee from "react-fast-marquee";
import { marqueeTags } from "../lib/data";
import { Star } from "lucide-react";

const MarqueeBand = () => {
  return (
    <div
      className="relative border-y border-[color:var(--nn-border)] py-6 md:py-8 overflow-hidden mask-fade-x"
      data-testid="marquee-band"
    >
      <Marquee gradient={false} speed={40} pauseOnHover>
        {marqueeTags.concat(marqueeTags).map((t, i) => (
          <div key={i} className="flex items-center gap-8 mx-6 text-[color:var(--nn-text)]">
            <Star size={14} className="text-[color:var(--nn-accent)]" />
            <span className="font-serif text-2xl md:text-3xl italic tracking-tight">
              {t}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBand;
